import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import template from './AddressCategoriesEditorV2.html?raw';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";
import "../MainCatalogSelect";
import Edit from '../../../moreCore/UI/Edit/Edit';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import MainCatalogSelectV2 from '../MainCatalogSelectV2';
import lang from 'dojo/_base/lang';

class AddressCategoriesEditorV2 extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    ac_Input_Description: MdsLax<InstanceType<typeof Edit>>;
    ac_Input_Note: MdsLax<InstanceType<typeof Edit>>;
    ac_Input_Order: MdsLax<InstanceType<typeof NumberInput>>;

    ac_Select_AddressMainCategory: MdsLax<InstanceType<typeof MainCatalogSelectV2>>;
    selectContainer: HTMLDivElement;

    isValid(): boolean {
        //Need to implement
        return true;
    }

    protected afterSetData() {
        super.afterSetData.apply(this, arguments as any);

        var mainCatageory = this.getAttributeValue("ref_address_main_category.ID");


        this.ac_Select_AddressMainCategory.setCatalog(MainCatalogs_Classes.AddressMainCategory,
            this.translations["General_Label_AddressMainCategory"], mainCatageory);
    }

    protected _onChanged(attribute: string, value: any) {
        
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.AddressCategory;
    }

    private _onChangeSelect() {
        var value = this.ac_Select_AddressMainCategory.getValue();
        this.setAttributeValue("ref_address_main_category", value, true);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.ac_Select_AddressMainCategory.placeAt(this.selectContainer);
        this.UiModder.domClass.add(this.ac_Select_AddressMainCategory.domNode, "");
        this.ac_Select_AddressMainCategory.on("change", lang.hitch(this, this._onChangeSelect))

        if (this.isNew) {
            this.ac_Select_AddressMainCategory.setCatalog(MainCatalogs_Classes.AddressMainCategory,
                this.translations["General_Label_AddressMainCategory"]);
        }

    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

mdsLazyProto(AddressCategoriesEditorV2.prototype, {
  ac_Select_AddressMainCategory: () => (new MainCatalogSelectV2()),
});
export default mdsWidget(AddressCategoriesEditorV2);
